import { Injectable } from '@angular/core';
import {
    EcommerceServiceUrlsGetHrefLangsRequestUIModel,
    EcommerceServiceUrlsGetHrefLangsResponseUIModel,
    EcommerceServiceUrlsGetSingleRequestUIModel,
    EcommerceServiceUrlsRepository,
} from '@socialonce/enganchesaragon-adminnav-lib';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { normalizeTranslatedUrlPath } from '../../utils/url-navigation.util';

@Injectable({
    providedIn: 'root',
})
export class UrlsService {
    constructor(private urlsRepository: EcommerceServiceUrlsRepository) {}

    getSingle(request: EcommerceServiceUrlsGetSingleRequestUIModel): Observable<string> {
        return this.urlsRepository.getSingle(request);
    }

    getHrefLangs(
        request: EcommerceServiceUrlsGetHrefLangsRequestUIModel
    ): Observable<EcommerceServiceUrlsGetHrefLangsResponseUIModel> {
        return this.urlsRepository.getHrefLangs(request).pipe(
            catchError(err => {
                return of({
                    data: [],
                    totalRows: 0,
                });
            })
        );
    }

    resolveTranslatedUrl(currentUrl: string, targetLanguage: string): Observable<string | null> {
        const translationRequest: EcommerceServiceUrlsGetSingleRequestUIModel = {
            url: currentUrl,
            targetLanguage,
        };

        return this.getSingle(translationRequest).pipe(
            map(url => normalizeTranslatedUrlPath(url)),
            catchError(() =>
                this.getHrefLangs({ url: currentUrl }).pipe(
                    map(response => {
                        const alternate = response.data.find(entry => entry.codeIso === targetLanguage);
                        return alternate?.url ? normalizeTranslatedUrlPath(alternate.url) : null;
                    })
                )
            )
        );
    }
}
